<table *ngIf="guestsData" class="guests-grid">
    <tr>
        <th *ngIf="!isBadgeExtension"><span appEllipsisTooltip>Photo</span></th>
        <th><span appEllipsisTooltip>First name</span></th>
        <th><span appEllipsisTooltip>Last name</span></th>
        <th><span appEllipsisTooltip>Entity/FSS</span></th>
        <th><span appEllipsisTooltip>Mobile number</span></th>
        <th><span appEllipsisTooltip>Agency</span></th>
        <th><span appEllipsisTooltip>Service area</span></th>
        <th><span appEllipsisTooltip>Date of joining</span></th>
        <th>
            <i class="icon-notification-bell"></i>
        </th>
    </tr>

    <tbody>
    <ng-container *ngFor="let guest of guestsData; let index = index">
        <tr *ngIf="index !== guestIndex">
            <td *ngIf="!isBadgeExtension">
                <img
                    [src]="guest.photoInfo ? (guest.photoInfo['file'] ? guest.photoInfo['file']?.url : defaultImageUrl) : defaultImageUrl"
                    alt="">
            </td>
            <td><span appEllipsisTooltip>{{ guest.firstName }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.lastName }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.entityOrFssName }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.phoneNumber }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.agency }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.serviceAreaName }}</span></td>
            <td>{{ guest.dateOfJoining | date: 'M/d/yy' }}</td>
            <td>
                <i
                    *ngIf="guest.comment; else iconPlaceholder"
                    class="icon-comment"
                    [tooltip]="guest.comment"
                ></i>
                <i
                    class="icon-edit"
                    [class.disabled]="guestToEdit || !showAddGuestButton"
                    [tooltip]="'Edit contractor'"
                    (click)="openEditGuest(guest, index)"
                ></i>
                <i
                    class="icon-delete"
                    [class.disabled]="guestToEdit || !showAddGuestButton"
                    [tooltip]="'Delete contractor'"
                    (click)="deleteGuest(guest)"
                ></i>
            </td>
        </tr>
        <tr *ngIf="isEdit && index === guestIndex" class="edit-row">
            <td [attr.colspan]="isBadgeExtension ? 8 : 9">
                <employee-edit-contractor
                    (guestEdited)="editGuest($event)"
                    (cancel)="cancel($event)"
                    [guestData]="guestToEdit"
                    [bloodGroups]="bloodGroups"
                    [isBadgeExtension]="isBadgeExtension"
                ></employee-edit-contractor>
            </td>
        </tr>
    </ng-container>

    </tbody>
</table>

<button
    class="button text with-icon add-button"
    *ngIf="showAddGuestButton"
    [class.disabled]="guestToEdit"
    (click)="addNewGuest()">
    <i class="icon-plus"></i>
    Add new contractor
</button>


<ng-template #iconPlaceholder>
    <i class="icon-placeholder"></i>
</ng-template>
